import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SaveAlt from '@material-ui/icons/SaveAlt';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    id,
    name = 'qrcode',
    onClickAction,
    textBtn,
    suffixes = null
  }) => {
    return (
      <Button color="primary" onClick={() => onClickAction(id, name, suffixes)}>
        <SaveAlt className={classes.leftIcon} />
        {textBtn}
      </Button>
    );
  }
);

export default withStyles(styles)(button);
